export default function SeoContentSection() {
  return (
    <section id="about" className="py-16 md:py-20 px-6 md:px-12 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left images */}
          <div className="flex-1 flex gap-4 w-full">
            <div className="w-[40%] aspect-[3/4] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20woven%20straw%20tote%20bag%20with%20soft%20cashmere%20scarf%20in%20muted%20sage%20green%20draped%20over%20the%20side%20on%20warm%20ivory%20linen%20surface%2C%20soft%20natural%20window%20light%20creating%20gentle%20shadows%2C%20editorial%20product%20photography%20with%20organic%20textures%2C%20warm%20earthy%20neutral%20palette%20with%20subtle%20green%20accents%2C%20relaxed%20lifestyle%20composition&width=600&height=800&seq=about-left-v2&orientation=portrait"
                alt="Superbuy Spreadsheet accessories category preview"
                title="Superbuy Spreadsheet - Accessories Collection"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="w-[60%] aspect-[3/4] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Beautiful%20terracotta%20leather%20crossbody%20bag%20alongside%20soft%20dusty%20rose%20linen%20scarf%20on%20warm%20ivory%20textured%20surface%2C%20soft%20natural%20light%20from%20side%20window%2C%20editorial%20product%20photography%20with%20rich%20material%20textures%2C%20warm%20earthy%20palette%20with%20blush%20and%20terracotta%20tones%2C%20artistic%20composition%20with%20thoughtful%20layering&width=800&height=800&seq=about-right-v2&orientation=landscape"
                alt="Superbuy Spreadsheet bags category preview"
                title="Superbuy Spreadsheet - Bags Collection"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Right content */}
          <div className="flex-1 max-w-lg">
            <span className="text-xs font-medium tracking-widest uppercase text-accent-600 whitespace-nowrap">Editor&apos;s Pick</span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mt-3 leading-tight">
              Superbuy Sheet<br />
              <span className="font-normal text-foreground-600">Shopping Intelligence</span>
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mt-5">
              The Superbuy Spreadsheet represents a revolutionary approach to fashion product discovery. Unlike traditional shopping methods that require endless scrolling through disparate websites, our carefully structured spreadsheet organizes 14 distinct product categories into one accessible resource. From premium sneakers to designer accessories, every link is verified and updated weekly to ensure you are always browsing the most current collections available.
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mt-3">
              What makes the Superbuy Spreadsheet truly unique is its community-driven curation process. Each category is refined based on shopper feedback, trending searches, and emerging fashion movements. Whether you are a seasoned collector hunting for rare streetwear pieces or a newcomer building your first wardrobe, the spreadsheet adapts to your discovery style.
            </p>

            {/* Article hub links */}
            <div className="mt-8 space-y-3">
              <p className="text-xs font-semibold tracking-widest uppercase text-foreground-400">In-Depth Guides</p>
              <a
                href="/superbuy-spreadsheet-guide"
                className="group flex items-center gap-3 bg-background-100 rounded-xl p-4 border border-background-200/60 hover:border-background-300/80 transition-all cursor-pointer"
              >
                <div className="w-9 h-9 rounded-full bg-secondary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-book-open-line text-secondary-600"></i>
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-foreground-900">Complete Superbuy Spreadsheet Guide</p>
                  <p className="text-xs text-foreground-500">Master the entire platform — 14 categories explained</p>
                </div>
                <i className="ri-arrow-right-line text-foreground-400 ml-auto group-hover:translate-x-1 transition-transform flex-shrink-0"></i>
              </a>
              <a
                href="/superbuy-spreadsheet-shoes-guide"
                className="group flex items-center gap-3 bg-background-100 rounded-xl p-4 border border-background-200/60 hover:border-background-300/80 transition-all cursor-pointer"
              >
                <div className="w-9 h-9 rounded-full bg-secondary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-footprint-line text-secondary-600"></i>
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-foreground-900">Shoes Category Deep Dive</p>
                  <p className="text-xs text-foreground-500">How to master footwear discovery in the spreadsheet</p>
                </div>
                <i className="ri-arrow-right-line text-foreground-400 ml-auto group-hover:translate-x-1 transition-transform flex-shrink-0"></i>
              </a>
              <a
                href="/comparison"
                className="group flex items-center gap-3 bg-background-100 rounded-xl p-4 border border-background-200/60 hover:border-background-300/80 transition-all cursor-pointer"
              >
                <div className="w-9 h-9 rounded-full bg-secondary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-scales-3-line text-secondary-600"></i>
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-foreground-900">Comparison: Spreadsheet vs Traditional Shopping</p>
                  <p className="text-xs text-foreground-500">See how the spreadsheet stacks up against other methods</p>
                </div>
                <i className="ri-arrow-right-line text-foreground-400 ml-auto group-hover:translate-x-1 transition-transform flex-shrink-0"></i>
              </a>
              <a
                href="/is-superbuy-spreadsheet-safe"
                className="group flex items-center gap-3 bg-background-100 rounded-xl p-4 border border-background-200/60 hover:border-background-300/80 transition-all cursor-pointer"
              >
                <div className="w-9 h-9 rounded-full bg-secondary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-check-line text-secondary-600"></i>
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-foreground-900">Is the Superbuy Spreadsheet Safe?</p>
                  <p className="text-xs text-foreground-500">Complete trust and verification guide</p>
                </div>
                <i className="ri-arrow-right-line text-foreground-400 ml-auto group-hover:translate-x-1 transition-transform flex-shrink-0"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}